module.exports = __webpack_public_path__ + "static/img/four_09.58e2a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_09.jpg
// module id = T77T
// module chunks = 3